import React from 'react';
import { MessageCircle } from 'lucide-react';
import { useAiChat } from './aichat/useAiChat';
import { ChatTeaser } from './aichat/ChatTeaser';
import { ChatPanel } from './aichat/ChatPanel';

/**
 * Floating AI chat bubble.
 *  - 60s after the user enters the page (and AFTER the gate is unlocked) a
 *    proactive teaser pops up: "Ciao 👋 Posso aiutarti?"
 *  - The teaser auto-dismisses after 12s if untouched, but the floating button
 *    remains accessible permanently.
 *  - Clicking opens a side panel chat backed by /api/public/chat (Emergent LLM).
 *
 * ★ Round 2 qualità — split: logica in ./aichat/useAiChat.js, UI in
 * ./aichat/ChatTeaser.jsx + ./aichat/ChatPanel.jsx. Comportamento INVARIATO.
 */
export default function AIChatBubble({ enabled = true }) {
  const chat = useAiChat({ enabled });

  if (!enabled) return null;

  return (
    <>
      {/* PROACTIVE TEASER — shown 60s after entering the page */}
      {chat.proactiveVisible && !chat.open && (
        <ChatTeaser
          greeting={chat.greeting}
          onOpen={chat.handleOpenChat}
          onDismiss={chat.handleDismissProactive}
        />
      )}

      {/* FLOATING BUTTON — always visible */}
      {!chat.open && (
        <button
          type="button"
          onClick={chat.handleOpenChat}
          className="fixed bottom-4 right-4 md:bottom-6 md:right-6 z-[7000] w-14 h-14 md:w-16 md:h-16 rounded-full bg-[var(--gp-forest)] text-[var(--gp-gold)] shadow-[0_15px_40px_-10px_rgba(0,0,0,0.5)] hover:scale-105 transition-transform flex items-center justify-center group"
          aria-label="Apri chat con l'assistente AI"
          data-testid="ai-chat-bubble"
        >
          <MessageCircle className="w-6 h-6 md:w-7 md:h-7" />
          <span className="absolute -top-1 -right-1 w-3.5 h-3.5 rounded-full bg-[#22c55e] border-2 border-[var(--surface-1)]" />
        </button>
      )}

      {/* CHAT PANEL */}
      {chat.open && (
        <ChatPanel
          messages={chat.messages}
          sending={chat.sending}
          input={chat.input}
          setInput={chat.setInput}
          sendMessage={chat.sendMessage}
          onClose={chat.handleClose}
          messagesEndRef={chat.messagesEndRef}
        />
      )}
    </>
  );
}
